<template>
  <div class="material">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="耗材规格">
          <el-input v-model.trim="filters.menuSpec" clearable></el-input>
        </el-form-item>
        <el-form-item label="耗材名称">
          <el-input v-model.trim="filters.menuName" clearable></el-input>
        </el-form-item>
        <el-form-item label="厂家">
          <el-input v-model.trim="filters.manufacturers" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
        <el-table-column sortable prop="menuName" label="耗材名称"></el-table-column>
        <el-table-column sortable prop="menuSpec" label="耗材规格"></el-table-column>
        <el-table-column sortable prop="manufacturers" label="厂家"></el-table-column>
        <el-table-column sortable prop="projectName" label="项目名称"></el-table-column>
        <el-table-column sortable prop="printProjectName" label="打印项目"></el-table-column>
        <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
        <el-table-column sortable prop="createTime" label="添加时间" width="100"></el-table-column>
        <el-table-column sortable align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">选择项目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增编辑身份弹框 -->
    <el-dialog center title="请选择项目" :visible.sync="dialogForm">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item>
          <el-checkbox-group class="cardName" size="medium" v-model="form.printProjectName">
            <el-checkbox style="display:block;" v-for="(item) in loadOptions" :key="item.id" :label="item.project">
              <span>{{item.project}}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="flex">
          <el-button @click="dialogForm = false">取消</el-button>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "material",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      tableData: [],
      multipleSelection: [],
      dialogForm: false,
      formData: {
        consumableMenuDtoList: [
          {
            menuName: '',
            menuSpec: '',
            price: '',
            manufacturers: "",
            accountingPrice: "",
          }
        ]
      },
      tableHeight: "",
      isId: '',
      form: {},
      loadOptions: [],

    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 380
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
    // 编辑时新增部位
    editAddDomain(index) {
      this.formData.consumableMenuDtoList.push({
        key: Date.now(),
        menuName: '',
        menuSpec: '',
        price: '',
        manufacturers: '',
        accountingPrice: ""
      });
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 编辑时删除部位
    editRemoveDomain(item, listIndex) {
      var index = this.formData.consumableMenuDtoList.indexOf(item)
      if (index !== -1) {
        this.formData.consumableMenuDtoList.splice(listIndex, 1)
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },

    handleEdit(idnex, row) {
      this.form = JSON.parse(JSON.stringify(row))
      if (this.form.printProjectName && this.form.printProjectName != '') {
        this.form.printProjectName = _g.turnNum(this.form.printProjectName.split(','))
      } else if (this.form.printProjectName == '' || this.form.printProjectName == null) {
        this.form.printProjectName = []
      }
      api.request('/skn/findConsumableMenuCodeById', {
        id: row.id,
      }, (res) => {
        // console.log(res)
        if (res.result == true) {
          let data = res.data
          this.loadOptions = data.projectList
          this.form.printProjectName = []
          if (this.loadOptions.length != 0) {
            this.dialogForm = true
          } else if (this.loadOptions.length == 0) {
            _g.toast("error", '暂无项目数据');
          }
          // 项目回显数据转换
          data.projectList.forEach(item => {
            data.printProjectNo.forEach(ele => {
              if (item.id == ele) {
                this.form.printProjectName.push(item.project)
              }
            });
          });
        } else {
          _g.toast("error", res.errMsg);
        }
      }, (err) => { })
    },
    onSubmit() {
      console.log(this.form);
      this.form.printProjectNo = []
      this.loadOptions.forEach(item => {
        this.form.printProjectName.forEach(ele => {
          if (item.project == ele) {
            this.form.printProjectNo.push(item.id)
          }
        });
      });
      console.log(this.form.printProjectNo);
      let data = {
        id: this.form.id,
        printProjectNo: this.form.printProjectNo.toString(),
      }
      api.request('/skn/updateConsumableMenuPrintProject', data, (res) => {
        // console.log(res)
        if (res.result == true) {
          _g.toast("success", "项目修改成功");
          this.dialogForm = false
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", res.errMsg);
        }
      }, (err) => { })
    },
    doAddgoods() {
      this.formData.createBy = Lockr.get('skinEmpId')
      if (this.isId) {
        api.requestQuiet("/skn/updateConsumableMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogForm = false
            _g.toast("success", '修改成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      } else if (!this.isId) {
        api.requestQuiet("/skn/createConsumableMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogForm = false
            _g.toast("success", '添加成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      }

    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
        menuSpec: this.filters.menuSpec,
        menuName: this.filters.menuName,
        manufacturers: this.filters.manufacturers,
        departmentCode: '001',
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.request('/skn/findConsumableMenuByCodePage', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.filters.pagination.total = parseInt(res.data.count)
      })
    },
  },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.material >>> .el-dialog {
  width: 70% !important;
}
.flex {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
</style>